import React, { useContext } from 'react';
import { LanguageContext } from '../../contexts/LanguageContext';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { language, toggleLanguage } = useContext(LanguageContext);

  const handleClick = () => {
    // Переключаем между двумя языками
    toggleLanguage(language === 'en' ? 'ru' : 'en');
  };

  return (
    <div className="language-switcher">
      <button
        onClick={handleClick}
        className="language-button"
        aria-label="Переключить язык"
        title="Переключить язык"
      >
        {language.toUpperCase()}
      </button>
    </div>
  );
};

export default LanguageSwitcher;